import * as React from "react";
import type { SVGProps } from "react";
const SvgRepeat = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17.707.293a1 1 0 1 0-1.414 1.414zM21 5l.707.707a1 1 0 0 0 0-1.414zm-4.707 3.293a1 1 0 0 0 1.414 1.414zM2 11a1 1 0 1 0 2 0zm5-6V4zm-.707 18.707a1 1 0 0 0 1.414-1.414zM3 19l-.707-.707a1 1 0 0 0 0 1.414zm4.707-3.293a1 1 0 1 0-1.414-1.414zM22 13a1 1 0 1 0-2 0zM16.293 1.707l4 4 1.414-1.414-4-4zm4 2.586-4 4 1.414 1.414 4-4zM4 11V9H2v2zm0-2a3 3 0 0 1 .879-2.121L3.464 5.464A5 5 0 0 0 2 9zm.879-2.121A3 3 0 0 1 7 6V4a5 5 0 0 0-3.536 1.464zM7 6h14V4H7zm.707 16.293-4-4-1.414 1.414 4 4zm-4-2.586 4-4-1.414-1.414-4 4zM20 13v2h2v-2zm0 2a3 3 0 0 1-.879 2.121l1.415 1.415A5 5 0 0 0 22 15zm-.879 2.121A3 3 0 0 1 17 18v2a5 5 0 0 0 3.535-1.465zM17 18H3v2h14z"
    />
  </svg>
);
export default SvgRepeat;
